enum OrganizationDefaultContent {
	base = 1,
	deals = 2,
	live = 3
}

export default OrganizationDefaultContent
